/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Features_Timeline_DescInputs */

const en_fc_home_features_timeline_desc = /** @type {(inputs: Fc_Home_Features_Timeline_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source and program monitors, three-point editing, ripple, roll, slip and slide trims, and J-K-L dynamic trimming while the footage plays.`)
};

/**
* | output |
* | --- |
* | "Source and program monitors, three-point editing, ripple, roll, slip and slide trims, and J-K-L dynamic trimming while the footage plays." |
*
* @param {Fc_Home_Features_Timeline_DescInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_features_timeline_desc = /** @type {((inputs?: Fc_Home_Features_Timeline_DescInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Features_Timeline_DescInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_features_timeline_desc(inputs)
});
export { fc_home_features_timeline_desc as "fc.home.features.timeline.desc" }